
import HttpClient from '../HttpService';

function list(page, limit, data) {
    return HttpClient.post(`/training-types/list?page=${page}&limit=${limit}`, data);
}

function getById(id) {
    return HttpClient.get(`/training-types/${id}`);
}

function create(data) {
    return HttpClient.post(`/training-types`, data);
}

function update(id, data) {
    return HttpClient.put(`/training-types/${id}`, data);
}

function destroy(id) {
    return HttpClient.delete(`/training-types/${id}`);
}

export default {
    list,
    getById,
    create,
    update,
    destroy
}
